
// import { UserBadgeComponent } from './../components/landing-page/user-badge/user-badge.component';
// import { NewCandidateComponent } from './../page/homepage/candidate/new-candidate/new-candidate.component';
// import { NewJobComponent } from './../page/homepage/layout-jobs/new-job/new-job.component';
 import { SocketService } from 'src/app/services/socket.service';
import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs';
import { SocketServiceStream } from './SocketServiceStream';
  @Injectable({
  providedIn: 'root'
})
export class StreamService {
  socketTopicmessageServers: Subscription;
  socketTopicmessageStream: Subscription;
  private streamData = new Subject<any>();
  response:any=null;
  userId=localStorage.getItem('userId');
   constructor(private _socket: SocketService,
    private _socket_stream: SocketServiceStream /* ,private userData:UserBadgeComponent,private jobs: NewJobComponent, private canidate :NewCandidateComponent */) {
    this.response = this.streamData.asObservable();
   }


// start socket for streamserver.

  startStream() {
     this._socket_stream.connect();
    setTimeout(() => {
      if (this._socket.reloadconnection().connected == false && this._socket_stream.reloadconnection().connected == false &&
        localStorage.getItem('userId')) {
       }
    }, 1000);
  }

  ngOnDestroy(): void {
    this._socket.ngOnDestroy();
    this._socket_stream.ngOnDestroy();
  }

  startTopic(){
    if( localStorage.getItem('userId')!=undefined && localStorage.getItem('userId')!=null) {
      // Prevent duplicate subscriptions
      if (this.socketTopicmessageStream && !this.socketTopicmessageStream.closed) {
        return;
      }
      // The stream socket owns this topic. If the server socket picked it up while
      // the stream socket was down, drop that stand-in so the payload is not
      // delivered twice into streamData.
      if (this.socketTopicmessageServers && !this.socketTopicmessageServers.closed) {
        this.socketTopicmessageServers.unsubscribe();
      }
      this.socketTopicmessageStream = this._socket_stream.onMessage('/topic/streams/' + localStorage.getItem('userId')).subscribe((response) => {
        this.response=response;
        this.streamData.next(response);
          setTimeout(() => {
               this.reloadAPI(response);
           }, 2000);
       });
    }
   }

   // server socket
   serverTopicfor_eyenotification(){
    if( localStorage.getItem('userId')!=undefined && localStorage.getItem('userId')!=null) {
      // Prevent duplicate subscriptions
      if (this.socketTopicmessageServers && !this.socketTopicmessageServers.closed) {
        return;
      }
      // Both sockets carry the SAME '/topic/streams/<userId>' topic into the SAME
      // streamData subject, and manageSocketConnections() re-arms both every 10s.
      // With both live, every server push ran each subscriber's handler twice.
      // The stream socket owns this topic; the server socket only stands in when
      // the stream socket is not subscribed.
      if (this.socketTopicmessageStream && !this.socketTopicmessageStream.closed) {
        return;
      }
      this.socketTopicmessageServers = this._socket.onMessage('/topic/streams/' + localStorage.getItem('userId')).subscribe((response) => {
        this.response=response;
        this.streamData.next(response);
            setTimeout(() => {
               this.reloadAPI(response);
           }, 500);
       });
    }
   }

// start socket for message
   startsocket_message() {
    this._socket.connect();
   }


   clearsubjectvalue(){
    setTimeout(() => {
      // this.streamData.next();
      // this.streamData.unsubscribe();

    }, 2000);
   }

  getstreamResponse(): Observable<any> {
    return this.streamData.asObservable();
  }

  getresponse(){
    return this.response;
  }


   clear(){
    return this.response=null;
  }

   reloadAPI(response){
    if(response.code=="00000" && response.responseEntity=="JOB"){
      // this.jobs.streamReloadApicallJobs();
    }else if(response.code=="00000" && response.responseEntity=="CANDIDATE"){
      // this.canidate.streamReloadApicallcandidate();
    }else if(response.code=="00000" && response.responseEntity=="CREDIT"){
      // this.userData.streamReloadApicallcandidate();
    }
     else if(response.code=="00000" && response.responseEntity=="POST"){
      // this.post.getReloadstream();

    } else if(response.code=="00000" && response.responseEntity=="HOME"){
      // this.header.streamReloadApicallcandidate();

    }


   }

   OnDestroy(){
    this._socket.ngOnDestroy();
    this._socket_stream.ngOnDestroy();
    if(this.socketTopicmessageServers){
      this.socketTopicmessageServers.unsubscribe();
    }
    if(this.socketTopicmessageStream){
      this.socketTopicmessageStream.unsubscribe();
    }

   }

}
